<div class="ui raised segment margin-bottom-10"  id="{{userReservation.id}}">
    <div class="ui stackable grid">
        <div class="two wide column">
            <i class="ui calendar huge icon"></i>
        </div>
        <div class="five wide column reservation-data">
            <h3>{{userReservation.email}}</h3>
            <p>{{userReservation.firstname + " " + userReservation.lastname}}</p>
            <p>{{userReservation.phone}}</p>
        </div>
        <div *ngIf="moreDetailed" class="five wide column reservation-data">
            <h3>Reservation</h3>
            <p>{{"Nombre de demi-journées: " + userReservation.reservations.length}}</p>
            <p>{{"Première journée: " + firstDate.toLocaleDateString()}}</p>
        </div>
        <div *ngIf="!moreDetailed" class="three wide column reservation-data"> </div>
        <div *ngIf="!moreDetailed" class="six wide column">
            <button class="ui button reservation-button" (click)="detailsRequired()">Détails</button>
            <button *ngIf="userReservation.validated" class="ui warning button reservation-button" (click)="updated.emit()">Modifier</button>
            <button *ngIf="!userReservation.validated" class="ui warning button reservation-button" (click)="validationRequired()">Valider</button>
            <button class="ui negative button reservation-button" (click)="removed.emit()">Supprimer</button>
        </div>
    </div>
    <div *ngIf="moreDetailed" class="margin-top-10">
        <div class="ui stackable grid">
            <div class="two wide column"></div>
            <div class="five wide column reservation-data">
                <h3>Véhicule</h3>
                <p>{{van.leasing.name}}</p>
                <p>{{van.plate}}</p>
            </div>
            <div class="nine wide column reservation-data">
                <h3>Commentaire</h3>
                <p>{{userReservation.comment}}</p>
            </div>
        </div>
    </div>

    <div *ngIf="moreDetailed">
        <button *ngIf="userReservation.validated" class="ui warning button reservation-button" (click)="updated.emit()">Modifier</button>
        <button *ngIf="!userReservation.validated" class="ui warning button reservation-button" (click)="validationRequired()">Valider</button>
        <button class="ui negative button reservation-button" (click)="removed.emit()">Supprimer</button>
    </div>
</div>



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/reservations/presentation/adminUserReservation/adminUserReservation.html